import { useEffect } from 'react';
import NavBar from './NavBar';
import { Outlet, useLocation, useNavigation, useParams } from 'react-router-dom';
import ModalProvider from '../context/ModalProvider';
import Footer from './Footer';
import Cookies from 'universal-cookie';
import { ConfiguratorSkeleton } from '../components/Skeletons';
import { pushPageContext, trackConfiguratorStarted, toSeriesFamilyName } from '../utils/analytics';

// Matches configurator route: /:productSlug/:seriesSlug/:modelName (with optional sub-page)
const configuratorRoutePattern = /^\/[^/]+\/[^/]+\/[^/]+/;

function nameFromSlug(slug) {
    if (!slug) return undefined;
    const dash = slug.indexOf('-');
    return decodeURIComponent(dash > 0 ? slug.substring(dash + 1) : slug);
}

export default function BuildMyKubota() {
    const navigation = useNavigation();
    const isLoadingConfigurator = navigation.state === "loading" &&
        configuratorRoutePattern.test(navigation.location?.pathname);

    const { productSlug, seriesSlug, modelName, pageName } = useParams();

    const cookies = new Cookies();

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    let cookie = cookies.get('bmkUc');
    var date = new Date(); // Now
    date.setDate(date.getDate() + 30); // Set now + 30 days as the new date

    cookies.set('bmkUc', ((cookie && cookie.length > 0) ? cookie : uuidv4()), { path: '/', expires: date });

    // Track Eloqua pageview on location change.
    // The `|| []` guard handles the case where this fires before GTM has loaded
    // the Eloqua tag — queued pushes are processed when the library initializes.
    const location = useLocation();
    useEffect(() => {
        window._elqQ = window._elqQ || [];
        window._elqQ.push(['elqTrackPageView', window.location.href]);

        let page_name = 'start';
        let current_step;
        if (modelName) {
            if (!pageName)                                      { page_name = 'configurator'; current_step = 'addons'; }
            else if (pageName === 'land-pride')                 { page_name = 'configurator'; current_step = 'landpride'; }
            else if (pageName === 'summary' || pageName === 'quote') { page_name = 'summary'; current_step = pageName; }
            else                                                { page_name = 'configurator'; current_step = pageName; }
        } else if (seriesSlug) {
            page_name = 'models';
        } else if (productSlug) {
            page_name = 'series';
        }

        pushPageContext({
            page_name,
            ...(productSlug && { category_name: nameFromSlug(productSlug) }),
            ...(seriesSlug && { series_name: toSeriesFamilyName(nameFromSlug(seriesSlug)) }),
            ...(modelName && { model_name: decodeURIComponent(modelName) }),
            ...(current_step !== undefined && { current_step }),
        });

        // Fires once on first entry to the configurator (no pageName = the base configurator view)
        if (modelName && !pageName) {
            trackConfiguratorStarted();
        }
    }, [location]);

    return (
        <ModalProvider>
            <div className="BuildMyKubota">
                <NavBar />

                <div className="container main-content">
                    <div className="text-center">
                        <div className="container_16">
                            {isLoadingConfigurator ? <ConfiguratorSkeleton /> : <Outlet />}
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </ModalProvider>
    );
}
